// extracted by mini-css-extract-plugin
module.exports = {"comp":"PowerSolution_comp__xd9hY","ani-fade-in-opacity":"PowerSolution_ani-fade-in-opacity__jz0nc","ani-fade-in-width":"PowerSolution_ani-fade-in-width__MI4C_"};